import React from 'react'
import {
  change as changeFieldValue, formValueSelector, reduxForm
} from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {selecionarReservaParaCriada, alterarFormaPagamentoReservaCriada} from '../../actions/reserva/selecionarReservaParaCriar';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import { paisesDDI } from '../../util/constantsUtil';

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col-lg-2 col-xl-2">Origem</div>
      <div className="col-lg-2 col-xl-2">Destino</div>
      <div className="col-lg-2 col-xl-2">Partida</div>
      <div className="col-lg-2 col-xl-2">Prestador</div>
      <div className="col-lg-2 col-xl-2">Ponto de embarque</div>
      <div className="col-lg-2 col-xl-2">Tipo de passagem</div>
    </div>
  </div>
);

export class ResumoCompra extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      mensagem: {
        tipo: '',
        texto: ''
      },
      criarReserva: null,
      urlImagem: ''
    };
  }

  UNSAFE_componentWillMount () {
    this.montarParametroReserva()
  }

  retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(passageiro) {
    return this.props.bloqueioPoltronasTemporario.bloqueios
            .filter(it => it.poltronaId === passageiro.poltronaId).map(it => it.uuid).shift();
  }

  montarParametroReserva () {
    const reservas = [];
    let valorTotalIda = 0;
    let valorTotalVolta = 0;
    if (this.props.passageirosIda.length > 0) {
      this.props.passageirosIda.forEach((pass) => {
        if (pass.opcaoDescontoMeia === 'ANTT') {
          valorTotalIda += Number(pass.valor)
        } else {
          valorTotalIda += Number(pass.valor)
        }
      })
    }
    if (this.props.passageirosVolta.length) {
      this.props.passageirosVolta.forEach((pass) => {
        if (pass.opcaoDescontoMeia === 'ANTT') {
          valorTotalVolta += Number(pass.valor)
        } else {
          valorTotalVolta += Number(pass.valor)
        }
      })
    }

    let cont = 0;

    this.props.passageirosIda.forEach((pass) => {
      let paisDDI = paisesDDI.find(it => it.id === pass.ddi)
      if (pass.siglaPais) {
        paisDDI = paisesDDI.find(it => it.sigla === pass.siglaPais)
      }      
      reservas.push(
        {
          idReserva: this.recuperarIdReservaRemarcacao(cont),
          passageiroDto: Object.assign({}, pass, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }),
          sentido: 'IDA',
          poltronaId: pass.poltronaId,
          desconto: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].descontoIda) === 0 ? null : Number(this.props.formasPagamento[0].descontoIda)  : null,
          acrescimoPassagem: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].acrescimoPassagemIda) : 0,
          itinerarioId: this.props.viagemIda.idItinerario,
          idCidadeOrigem: this.props.origem.id,
          idCidadeDestino: this.props.destino.id,
          valor: this.props.viagemIda.preco,
          embarque: this.props.viagemIda.embarque,
          garantiaPrecoUuid: this.retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(pass),
          tarifaSeguro: pass.vendaSeguro ? this.props.viagemIda.tarifaSeguro : 0.00          
        }
      );
      cont += 1;
    });

    if (this.props.passageirosVolta.length > 0) {
      this.props.passageirosVolta.forEach((pass) => {
        let paisDDI = paisesDDI.find(it => it.id === pass.ddi)
        if(pass.siglaPais) {
          paisDDI = paisesDDI.find(it => it.sigla === pass.siglaPais)
        }
        reservas.push(
          {
            idReserva: this.recuperarIdReservaRemarcacao(cont),
            passageiroDto: Object.assign({}, pass, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }),
            poltronaId: pass.poltronaId,
            sentido: 'VOLTA',
            itinerarioId: this.props.viagemVolta.idItinerario,
            desconto: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].descontoVolta) === 0 ? null : Number(this.props.formasPagamento[0].descontoVolta) : null,
            acrescimoPassagem: this.props.formasPagamento && this.props.formasPagamento.length ? Number(this.props.formasPagamento[0].acrescimoPassagemVolta) : 0,
            idCidadeOrigem: this.props.destino.id,
            idCidadeDestino: this.props.origem.id,
            valor: this.props.viagemVolta.preco,
            embarque: this.props.viagemVolta.embarque,
            garantiaPrecoUuid: this.retornarGarantiaPrecoUuidPorBloqueioPoltronasTemporario(pass),
            tarifaSeguro: pass.vendaSeguro ? this.props.viagemVolta.tarifaSeguro : 0.00            
          }
        );
        cont += 1;
      });
    }

    const pagamentos = [];
    const pagamentoTEF = [];
    pagamentoTEF.push({
        tipo: 'Pagamento via TEF',
              codigoTipo: 'TEF',
              base64Comprovante: '',
              numeroComprovante: '',
              valor: valorTotalVolta + valorTotalIda,
              quantidadeParcelas: 1
    });

    this.props.adicionarFormasPagamento(pagamentoTEF);

    if (valorTotalVolta + valorTotalIda === 0) {
      pagamentos.push({
        tipo: 'Dinheiro',
        codigoTipo: 'DINHEIRO',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: valorTotalVolta + valorTotalIda,
        quantidadeParcelas: 1
      });
      this.props.adicionarFormasPagamento(pagamentos);
    }


    // Garantir que dadosPagamento existe e tem ddiComprador
    const ddiComprador = this.props.dadosPagamento && this.props.dadosPagamento.ddiComprador ? this.props.dadosPagamento.ddiComprador : null
    let paisDDI = ddiComprador ? paisesDDI.find(it => it.id === ddiComprador) : null
    if (!paisDDI) {
      paisDDI = paisesDDI.find(it => it.sigla === 'BR') || paisesDDI[0]
    }
    
    const criarReserva = {
      ehVendaEmMassa: this.props.ehVendaEmMassa,
      tipoVeiculo: this.props.viagemIda.tipoVeiculo,
      cidadeOrigem: this.props.origem.id,
      cidadeDestino: this.props.destino.id,
      empresaId: this.props.empresaSelecionada.id,
      embarque: this.props.embarque,
      reservas,
      pontoVenda: 'TERMINAL',
      formasPagamentoDto: !this.props.formasPagamento ? pagamentos : this.props.formasPagamento,
      dadosCompradorDto: this.props.dadosPagamento ? Object.assign({}, this.props.dadosPagamento, { ddi: paisDDI.ddi, siglaPais: paisDDI.sigla }) : null,
      usuarioDirecionado: this.props.usuarioSelecionadoVendaDirecionada && this.props.usuarioSelecionadoVendaDirecionada.id ? this.props.usuarioSelecionadoVendaDirecionada.id : null,
      pedidoId: null,
      habilitadoZerarValorMultaRemarcacao: this.props.habilitadoZerarValorMultaRemarcacao

    };
        
    this.props.selecionarReservaParaCriada(criarReserva);
  }

  recuperarIdReservaRemarcacao (index) {
    if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
      return this.props.reservasSelecionadasRemarcacao[index].id
    }
    return null
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formReserva');
    this.limparMensagem();
  }

  ehpagamentoTEF(){

    return this.props.pagamentoTEF

  }

  alteraFormaPagamento(formaPagamento) {
    this.props.alterarFormaPagamentoReservaCriada(formaPagamento).then(() => {
          this.props.pagarPedido(formaPagamento);
        })
  }


  loadBotoes (forma) {
    if(forma.situacao === 'APROVADO'){
      return <React.Fragment>
        <i className="fas fa-check text-success fa-2x"></i>
      </React.Fragment>
    }
    return (
        <React.Fragment>
          <button className="btn btn-sm btn-laranja"
                  style={{cursor: 'pointer'}}
                  disabled={forma.habilitado === false}
                  onClick={() => this.alteraFormaPagamento(forma)}>Pagar
          </button>
        </React.Fragment>)
  }
  exibirFormasPagamento () {
    if (!this.props.criarReserva.formasPagamentoDto || this.props.criarReserva.formasPagamentoDto.length === 0) {
      return ''
    }
    return <React.Fragment>
      <h4>Formas de Pagamento</h4>
      <table className="table table-sm table-bordered text-center mt-2 cinza-zebrado">
        <thead>
        <tr>
          <th scope="col">Tipo</th>
          <th scope="col">Valor</th>
          <th scope="col">Parcelas</th>
          <th scope="col">Número comprovante</th>
          <th scope="col">Situação</th>
        </tr>
        </thead>
        <tbody>
        {this.props.criarReserva.formasPagamentoDto.map((forma, index) => <tr key={index}>
          <td>{forma.tipo}</td>
          <td>{forma.valor.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL'
          })}</td>
          <td>{forma.quantidadeParcelas ? forma.quantidadeParcelas : '-'}</td>
          <td>{forma.numeroComprovante ? forma.numeroComprovante : '-'}</td>
          <td>{this.ehpagamentoTEF() ?
              this.loadBotoes(forma):
               '-'}
          </td>
        </tr>)
        }
        </tbody>
      </table>
          {
            this.ehpagamentoTEF() && (
              <div className='alert alert-warning text-left mt-2' style={{ fontSize: '14px' }}>
                Clique no botão <strong>PAGAR</strong> para realizar o pagamento via TEF. Assim que o pagamento for finalizado e confirmado, você será redirecionado automaticamente para a tela de impressão do bilhete.
              </div>
            )
          }

    </React.Fragment>
  }

  exibirResumo (origem, destino, viagem, sentido) {
    return (<React.Fragment>
      <h4>{sentido}</h4>
      <CabecalhoTabela/>
      <div className="lista-table">
        <div className="geral">
          <div className="resumo" style={{ backgroundColor: '#E9EEF2' }}>
            <div className='row'>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Origem:&nbsp;</span>
                {origem.nome}
                <br/>
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Destino:&nbsp;</span>
                {destino.nome}
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Partida:&nbsp;</span>
                {viagem.dataPartida} às {viagem.horaPartida}
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Prestador:&nbsp;</span>
                {viagem.nomePrestador ? viagem.nomePrestador : ''}
              </div>
              <div className="col-lg-4 col-xl-4">
                <span className="titulo-mobile">Embarque:&nbsp;</span>
                {viagem.embarque}
              </div>
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Veículo:&nbsp;</span>{viagem.descricaoTipoVeiculo}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className='row'>
          {this.exibirPassageiros(sentido, viagem.pedagio)}
        </div>
      </div>
    </React.Fragment>)
  }


  exibirPassageiros (sentido, pedagio){
    return this.props.criarReserva.reservas.filter(it => it.sentido === sentido)
      .map(reserva => <div key={reserva.numeroPoltrona} className="col-lg-6 col-md-6 col-12 mb-2 mt-4 d-flex">
        <div className="card card-default text-left cinza-zebrado flex-fill">
          <div className='ml-2 mt-2 mb-2'>
            <p className='text-center'><strong>{reserva.passageiroDto.nome}</strong></p>
            <p><strong>Poltrona: </strong><span>{reserva.passageiroDto.numeroPoltrona}</span></p>
            <p><strong>CPF: </strong><span>{reserva.passageiroDto.cpfPassageiro}</span></p>
            <p><strong>Documento com foto: </strong><span>{reserva.passageiroDto.documentoComFoto}</span></p>
            <p><strong>Tipo de documento com foto: </strong><span>{reserva.passageiroDto.tipoDocumento}</span></p>
            <p><strong>Valor: </strong><span>{Number(reserva.passageiroDto.valor)
              .toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</span></p>
            <p><strong>Taxa de embarque: </strong><span>{reserva.passageiroDto.taxaEmbarque && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
              ? Number(reserva.passageiroDto.taxaEmbarque)
                .toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                }) : 'R$ 0,00'}</span></p>
            <p><strong>Pedágio: </strong><span>{pedagio && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
                ? Number(pedagio)
                    .toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    }) : 'R$ 0,00'}</span></p>
            <p><strong>Seguro: </strong><span>{reserva.tarifaSeguro && !this.props.ehGratuidadeTotal(reserva.passageiroDto.tipoEmissao)
                ? Number(reserva.tarifaSeguro)
                    .toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    }) : 'R$ 0,00'}</span></p>
            <p><strong>Tipo de emissão: </strong><span>{reserva.passageiroDto.tipoEmissao}</span></p>
            {this.exibirCrianca(reserva.passageiroDto.criancaDto)}
          </div>
        </div>
      </div>)
  }

  exibirCrianca (crianca) {
    if (crianca) {
      return (<React.Fragment>
        <p className='text-center'><strong>Criança de colo</strong></p>
        <p><strong>Nome: </strong><span>{crianca.nome}</span></p>
        <p><strong>CPF: </strong><span>{crianca.cpfCrianca}</span></p>
        <p><strong>Data de Nascimento: </strong><span>{crianca.dtNascimentoCrianca}</span></p>
        <p><strong>Documento com Foto: </strong><span>{crianca.documentoCriacaComFoto}</span></p>
      </React.Fragment>)
    }
    return '';
  }

  render () {
    if (!this.props.criarReserva) {
      return ''
    }
    return (
      <React.Fragment>
        <div className="card text-center border-0">
          <hr/>
          {this.exibirResumo(this.props.origem, this.props.destino, this.props.viagemIda, 'IDA')}
          {this.props.viagemVolta ? <React.Fragment>
            <hr/>
            {this.exibirResumo(this.props.destino, this.props.origem, this.props.viagemVolta, 'VOLTA')}</React.Fragment> : ''}
          <hr/>
          {this.exibirFormasPagamento()}
        </div>
      </React.Fragment>
    )
  }
}

export function

mapStateToProps (state) {
  return {
    embarqueVolta: formValueSelector('formReserva')(state, 'embarqueVolta'),
    embarqueIda: formValueSelector('formReserva')(state, 'embarqueIda'),
    usuariosEmpresa: state.usuariosEmpresa,
    ehVendaEmMassa: state.ehVendaEmMassa,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    poltronasSelecionadas: state.poltronasSelecionadas,
    origem: state.origem,
    destino: state.destino,
    empresaSelecionada: state.empresaSelecionada,
    passageirosVolta: state.passageirosVolta,
    dadosPagamento: state.dadosPagamento,
    formasPagamento: state.formasPagamento,
    passageirosIda: state.passageirosIda,
    criarReserva: state.criarReserva,
    reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
    bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
    usuarioSelecionadoVendaDirecionada: state.usuarioSelecionado
  }
}


export const
  mapDispatchToProps = dispatch => (
    bindActionCreators({
      changeFieldValue,
      selecionarReservaParaCriada,
      adicionarFormasPagamento,
      alterarFormaPagamentoReservaCriada
    }, dispatch)
  );

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'formReserva',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(
    ResumoCompra
  )
);
